<template>
    <div>
        <Form ref="formInline" inline  :label-width="150" style="margin: 10px 20px 0px 0px" label-position="left">
            <Row>
                <Col :lg="8" :xs="13">
                  <FormItem label="休假代码(类型)：">
                      <Select  v-model="lvCtrl.lvType" clearable style="width: 300px;" >
                        <Option v-for="(item,index) in leaveTypeList" :key="item.code" :value="item.code">{{item.c_name}}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col :lg="8" :xs="13">
                  <FormItem label="休假名称：">
                      <Input  v-model="lvCtrl.cDescription "/>
                  </FormItem>
                </Col>
                <Button  @click="pageInfo.pageNo=1,total=0,getData()"><!-- 检索 -->{{$t('Search')}}</Button>
              </Row>
             
          </Form>
        <Form>
            <Table  stripe border :columns="columns" :loading="loading" :data="dataTable">
                <template slot="slot" slot-scope="{ row }">
                    <Button type="warning"  size="small" @click="openPop(row)">编辑</Button>
                    <Button type="error"  size="small" @click="deleteInfo(row)">删除</Button>
                </template>
               
            </Table>
            <Page  :total="total" style="float:left;margin-top: 15px;" @on-change="pageChange" />
            <div class="addButton">
                <Button type="primary" icon="md-add"  @click="addData()">新增</Button>
            </div>
        </Form>
        <Modal v-model="popShow" width="80%" :title="itemTitle==1 ? '新增' : '编辑'"> 
            <Form :modal="formItem" ref="formItem"  :label-width="185" label-position="left" >
                  <div style="border: 1px solid #dcdee2;width:90%;margin: 5px auto 25px;padding: 5px 10px">
                      <div>说明</div>
                      <div style="text-indent: 20px;">1.显示名称在是休假申请中，休假类型选择时使用；</div>
                      <div style="text-indent: 20px;">2.最小申请单位、最小申请数、最大申请数、全年可用数的值为0时，不做校验；</div>
                      <!-- <div style="text-indent: 20px;">3.提前申请天数设定(工作日)的值须设置负值，值为0时，不做校验，例如：-1；</div> -->
                      <div style="text-indent: 20px;">3.人事状态全不勾选时，不做匹配；</div>
                  </div>
                  <Row>
                    <Col span="10" offset="1">
                      <FormItem label="休假代码(类型)：">
                          <Select :disabled="itemTitle==1 ? false : true" v-model="formItem.lvType" clearable @on-change="getLeaveCname">
                              <Option v-for="(item,index) in leaveTypeList" :key="item.code" :value="item.code">{{item.code}}</Option>
                          </Select>
                      </FormItem>
                    </Col>
                    <Col span="10" offset="2">
                      <FormItem label="休假名称：">
                          <Input disabled  v-model="formItem.cDescription "/>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span="10" offset="1">
                      <FormItem label="休假展示名称(中文)：">
                          <Input  v-model="formItem.dispCDescription "/>
                      </FormItem>
                    </Col>
                    <Col span="10" offset="2">
                      <FormItem label="休假展示名称(英文)：">
                          <Input  v-model="formItem.dispEDescription "/>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col span="5" offset="1">
                      <FormItem label="休假申请单位：" >
                        <Select :clearable="true" v-model="formItem.unit" style="width: 100px;" >
                            <Option v-for="item in xjdwList" :value="item.code" :key="item.code">{{ item.name1 }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                        <FormItem label="最小申请单位：" >
                        <InputNumber  style="width: 70px" :min="0"   v-model="formItem.minUnitVal" /> 
                        </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                        <FormItem label="最小申请数：" >
                        <InputNumber  style="width: 70px" :min="0"   v-model="formItem.minVal" /> 
                        </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                        <FormItem label="最大申请数：" >
                        <InputNumber  style="width: 70px" :min="0"  v-model="formItem.maxVal" /> 
                        </FormItem>
                    </Col>
                   
                </Row>
                <Row>
                    <Col span="5" offset="1">
                        <FormItem label="展示顺序：" >
                        <InputNumber  style="width: 70px" :min="0"   v-model="formItem.sortNo" /> 
                       </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                      <FormItem label="是否使用：" >
                        <Checkbox true-value="1" false-value="0" v-model="formItem.enable"></Checkbox>
                      </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                      <FormItem label="是否参考日历：" >
                          <Checkbox true-value="1" false-value="0" v-model="formItem.matchType"></Checkbox>
                      </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                        <FormItem label="全年可用数：" >
                           <InputNumber  style="width: 70px" :min="0"   v-model="formItem.usedMaxYear" /> 
                        </FormItem>
                    </Col>
                </Row>
                
                  <Row>
                    <Col span="5" offset="1" >
                      <FormItem label="匹配性別：">
                        <Select :clearable="true" v-model="formItem.matchSex" style="width: 100px;" >
                            <Option v-for="item in xbList" :value="item.code" :key="item.code">{{ item.name1 }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                      <FormItem label="婚姻状况：">
                        <Select :clearable="true" v-model="formItem.matchMarried" style="width: 100px;" >
                            <Option v-for="item in hyzkList" :value="item.code" :key="item.code">{{ item.name1 }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                        <FormItem label="试用期是否可用:" >
                            <Checkbox true-value="1" false-value="0" v-model="formItem.allowShiyongqi"></Checkbox>
                        </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                        <FormItem label="附件是否可上传：" >
                            <Checkbox true-value="1" false-value="0" v-model="formItem.allowAttcheNull"></Checkbox>
                        </FormItem>
                    </Col>
                  </Row>
                  
                <Row>
                    <Col span="5" offset="1">
                      <FormItem label="提前申请天数设定：" >
                        <InputNumber  style="width: 70px" :min="0"   v-model="formItem.allowApplyDay" /> 
                      </FormItem>
                    </Col>
                    <Col span="5" offset="1">
                        <FormItem label="提前申请类型：" >
                            <RadioGroup v-model="formItem.applyType" >
                                <Radio v-for="(item ,index) in applyType" :key="index" :label="item.code">{{item.name}}</Radio>
                                <!-- <span @click="clear()"><Radio :label="$t('New')"></Radio></span> -->
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="22" offset="1">
                        <FormItem label="匹配人事状态：" >
                          <CheckboxGroup v-model="formItem.match_emp_type1">
                              <Checkbox style="margin-right: 15px !important;" v-for="(item,index) in rsztList" :key="index" :label="item.code">{{item.name}}</Checkbox>
                          </CheckboxGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="22" offset="1">
                      <FormItem label="备注：" >
                            <Input type="textarea" :autosize="{minRows: 5,maxRows: 5}"  v-model="formItem.remark" placeholder=""> </Input>
                      </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer"  >
                <Button @click="cancelLeaveData">取消</Button>
                <Button @click="saveLeaveData">保存</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    data(){
        return{
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            total:0,
            rsztList:[],
            leaveTypeList:[],
            itemTitle:0,
            loading:false,
            dataTable:[],
            popShow:false,
            lvCtrl:{},
            formItem:{
                match_emp_type1:[]
            },
            applyType:[
                {
                    code : "0",
                    name : "日历"
                },
                {
                    code : "1",
                    name : "排班"
                }
            ],
            xbList:[
            {
                    name1: '男',
                    code: 'M'
                },
                {
                    name1: '女',
                    code: 'F'
                },
                {
                    name1: '所有',
                    code: 'ALL'
                },
            ],
            xjdwList: [
                {
                    name1: '日',
                    code: 'D'
                },
                {
                    name1: '时',
                    code: 'H'
                },
            ],
            hyzkList: [
                {
                    name1: '已婚',
                    code: 'M'
                },
                {
                    name1: '未婚',
                    code: 'S'
                },
                {
                    name1: '所有',
                    code: 'ALL'
                },
            ],
            columns:[
            {
                title: '休假代码(类型)',
                key: 'lvType',
                align: 'center'
            },
            {
                title: '休假名称',
                key: 'cDescription',
                align: 'center'
            },
            {
                title: '休假展示名称(中文)',
                key: 'dispCDescription',
                align: "center"
            },
            {
                title: '休假展示名称(英文)',
                key: "dispEDescription",
                align: "center"

            },
            {
                title: '是否使用',
                key: "enable",
                align: "center",
                render: (h, params) => {
                    return h(
                      "span", 
                        params.row.enable == '1' ? "使用" : "未使用"
                    );
                  },
            },
            {
                title: '是否参考日历',
                key: "matchType",
                align: "center",
                render: (h, params) => {
                    return h(
                      "span", 
                        params.row.matchType == '1' ? "使用" : "未使用"
                    );
                  },
            },
            {
                title: '编辑',
                align: "center",
                slot:"slot"
            },
            ],
        }
    },
    created(){
        this.getData()
        this.getLabel()
    },
    methods:{
        getLeaveCname(){
            this.leaveTypeList.map((item) => {
                if(this.formItem.lvType==item.code){
                    this.formItem.cDescription = item.c_name
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getData()
        },
        getData(){
            this.loading=true
            let json={
                lvType:this.lvCtrl.lvType,
                cDescription:this.lvCtrl.cDescription,
                pageNo:this.pageInfo.pageNo,
                pageSize:this.pageInfo.pageSize
            }
            axios.post('/lvCode/selectLeaveData',json).then(res => {
                this.loading=false
                if(res) {
                    this.dataTable=res.data
                    this.total=Number(res.pageInfo.total)
                    this.dataTable.map(item => {
                        if(item.matchEmpType){
                            item.matchEmpType ? item.match_emp_type1 = item.matchEmpType.split(',') : ''
                        }
                    })
                }
            })
        },
        openPop(row){
            this.itemTitle=0,
            this.popShow=true
            this.formItem=JSON.parse(JSON.stringify(row))
            this.formItem.enable = row.enable=="1" ? "1" : "0"
            this.formItem.matchType = row.matchType=="1" ? "1" : "0"
            this.formItem.allowShiyongqi = row.allowShiyongqi=="1" ? "1" : "0"
            this.formItem.allowAttcheNull = row.allowAttcheNull=="1" ? "1" : "0"
            if(row.matchEmpType){
                this.formItem.match_emp_type1 = row.matchEmpType.split(',')
            }
        },
        addData(){
            this.formItem={
                enable:"0",
                matchType:"0",
                minUnitVal:null,
                minVal:null,
                maxVal:null,
                usedMaxYear:null,
                allowApplyDay:null,
                sortNo:null,
                allowShiyongqi:"0",
                allowAttcheNull:"0"
            },
            console.log(this.formItem)
            this.itemTitle=1,
            this.popShow=true
        },
        getLabel(){
            axios.post('/lvCode/selectLeaveLabel',{}).then(res => {
                if(res) {
                    this.rsztList=res.HRSTATUS
                }
                this.getLeaveTypeList()
            })
        },
        getLeaveTypeList(){
            axios.post('/lvCode/selectLeaveDataLabel',{}).then(res => {
                this.leaveTypeList = res.leaveTypeList
            })
           
        },
       
        saveLeaveData(){
            if(!this.formItem.unit){
                this.$Message.error("休假申请单位必须选择")
                return
            }
            if(!this.formItem.matchSex){
                this.formItem.matchSex = 'ALL'
            }
            if(!this.formItem.matchMarried){
                this.formItem.matchMarried = 'ALL'
            }
            this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                  this.submitSave()
                }
            })
        },
        submitSave(){
             // 新增编辑接口不同
             if(this.itemTitle == 1){
                 if(this.formItem.match_emp_type1){
                    this.formItem.matchEmpType=this.formItem.match_emp_type1.toString()
                 }
                 let obj={
                     ...this.formItem
                 }
                 axios.post('/lvCode/insertLeaveData',obj).then(res => {
                    if(res){
                        this.popShow=false;
                        this.$Message.success("新增成功")
                        this.getData()
                        
                    }
                 })
            }else{
                this.formItem.matchEmpType=this.formItem.match_emp_type1.toString()
                let obj={
                     ...this.formItem
                 }
                 axios.post('/lvCode/updateLeaveData',obj).then(res => {
                    if(res){
                        this.popShow=false;
                        this.$Message.success("修改成功")
                        this.getData()
                    }
                 })
            }
        },
        cancelLeaveData(){
            this.popShow=false
        },
        deleteInfo(row){
            this.$Modal.confirm({
                title: this.$notice('deletion'),
                onOk: () => {
                    let obj={ 
                        id:row.id
                    }
                axios.post('/lvCode/deleteLeaveData',obj).then(res => {
                    if(res){
                        this.$Message.success("删除成功")
                        this.getData()
                    }
                })
                }
            })
        }
    }
    }
</script>
<style lang="scss" scoped>
.addButton{
    margin-top: 20px;
    text-align: right;
    padding-bottom: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/LvCtrlSet.vue